class Website {
	constructor() {
		this.init();
	}

	init() {
		const carousel = new Carousel();
		const tabs = new Tabs();
		const accordions = new Accordions();

		// const m = new Mapplic();

		const menu = new FixMenu();

		var $grid = $(".actus__grid").imagesLoaded(function() {
			// init Masonry after all images have loaded
			$(".actus__grid").masonry({
				itemSelector: ".card",
				columnWidth: ".grid-sizer",
				// gutter: 0,
				gutter: ".gutter-sizer",
				percentPosition: true
			});
		});

		var scroll = new SmoothScroll('.js-smoothscroll, .menu a[href*="#"]', {
			header: ".header"
		});

		$(".js-trigger").on("click", e => {
			const target = `#${$(e.currentTarget).attr("data-id")}`;
			const header = $(target).find(".socks__header");

			if (!header.hasClass("is-active")) {
				header.trigger("click");
			}
		});

		$(".menu-item a").on("click", e => {
			if (window.innerWidth <= 768) {
				$(".nav-button").trigger("click");
			}
		});

		/// TARTE
		tarteaucitron.init({
			privacyUrl: "" /* Privacy policy url */,

			hashtag: "#tarteaucitron" /* Open the panel with this hashtag */,
			cookieName: "tarteaucitron" /* Cookie name */,

			orientation: "bottom" /* Banner position (top - bottom) */,
			showAlertSmall: false /* Show the small banner on bottom right */,
			cookieslist: true /* Show the cookie list */,

			adblocker: false /* Show a Warning if an adblocker is detected */,
			AcceptAllCta: true /* Show the accept all button when highPrivacy on */,
			highPrivacy: true /* Disable auto consent */,
			handleBrowserDNTRequest: false /* If Do Not Track == 1, disallow all */,

			removeCredit: false /* Remove credit link */,
			moreInfoLink: true /* Show more info link */,
			useExternalCss: false /* If false, the tarteaucitron.css file will be loaded */,

			//"cookieDomain": ".my-multisite-domaine.fr", /* Shared cookie for multisite */

			readmoreLink: "/cookiespolicy" /* Change the default readmore link */
		});

		// GTAG
		tarteaucitron.user.gajsUa = "UA-XXXXXXXX-X";
		tarteaucitron.user.gajsMore = function() {
			/* add here your optionnal _ga.push() */
		};
		(tarteaucitron.job = tarteaucitron.job || []).push("gajs");

		// ReCaptcha
		(tarteaucitron.job = tarteaucitron.job || []).push("recaptcha");

		// marqueur du service
		var _gaq = _gaq || [];
		_gaq.push(["_setAccount", "UA-XXXXXXX-X"]);
		_gaq.push(["_trackPageview"]);

		(function() {
			var ga = document.createElement("script");
			ga.type = "text/javascript";
			ga.async = true;
			ga.src = ("https:" == document.location.protocol ? "https://ssl" : "http://www") + ".google-analytics.com/ga.js";
			var s = document.getElementsByTagName("script")[0];
			s.parentNode.insertBefore(ga, s);
		})();

		///////////////////// MAPPLIC
	}
}

// Entry point
document.addEventListener("DOMContentLoaded", function() {
	const website = new Website();
});
